import { ModifierSetDto } from "services/modifierSets/restModels";

import { ModifierDraft } from "features/ModifierSets/types";

export const toModifierDrafts = (modifierSet: ModifierSetDto | null): ModifierDraft[] =>
    (modifierSet?.modifiers || []).map((modifier) => ({
        id: modifier.id,
        name: { ...modifier.name },
        sellPrice: modifier.sellPrice.price,
        isInStopList: modifier.isInStopList,
        externalId: modifier.externalId,
    }));

// Пустое поле лимита читаем как 0 — форма не должна падать на промежуточном вводе.
export const toCount = (value: string): number => {
    const parsed = parseInt(value, 10);

    return isNaN(parsed) ? 0 : parsed;
};
